import { Component, OnInit } from '@angular/core';
import { ModalLetUsHelpYouService } from '../../services/modal-let-us-help-you.service';

@Component({
  selector: 'app-let-us-help-you-modal',
  templateUrl: './let-us-help-you-modal.component.html',
  styleUrls: ['./let-us-help-you-modal.component.scss']
})
export class LetUsHelpYouModalComponent implements OnInit {

  public selectedItem = null;

  public eventType = '';

  constructor(
    public modalLetUsHelpYouService: ModalLetUsHelpYouService,
  ) { }

  ngOnInit(): void {
    this.eventType = 'in-person';
    this.selectedItem = 1
  }

  selectItem(item) {
    switch (item) {
      case 1:
        this.eventType = 'in-person';
        this.selectedItem = item;
        break;
      case 2:
        this.eventType = 'hybrid';
        this.selectedItem = item;
        break;
      case 3:
        this.eventType = 'virtual';
        this.selectedItem = item;
        break;
      default:
        break;
    }
  }
  
  onCloseClick() {
    this.modalLetUsHelpYouService.close();
  }

  openLink(link) {
    window.open(link, '_blank');
  }
}
